var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "57", height: "56", viewBox: "0 0 57 56", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("circle", { opacity: ".12", cx: "28.5", cy: "28", r: "28", fill: "#018489" }),
    React.createElement("path", { d: "M28.5 31C31.8137 31 34.5 28.3137 34.5 25 34.5 21.6863 31.8137 19 28.5 19 25.1863 19 22.5 21.6863 22.5 25 22.5 28.3137 25.1863 31 28.5 31zM19.4043 36.2491C20.3264 34.6531 21.6522 33.3278 23.2487 32.4064 24.8451 31.485 26.6559 31 28.4992 31 30.3424 31 32.1532 31.4851 33.7497 32.4065 35.3461 33.3279 36.6719 34.6533 37.594 36.2493", stroke: "#018489", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});